module.exports = __webpack_public_path__ + "static/media/25_plantilla_combo_cuadrada_marco_comida_70.decd702b.png";